module.exports = __webpack_public_path__ + "img/wild-rag-deck-05.4d60b480.jpeg";